// @ts-nocheck
import React, { useEffect, useState } from 'react'
import FileCard from './agregar-difusion/redactar-mail/FileCard';
import BotonParaSeleccionarArchivo from './agregar-difusion/redactar-mail/BotonParaSeleccionarArchivo';
import DropZone from './agregar-difusion/redactar-mail/DropZone';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import { FILES_PERMITIDOS } from '../../Contantes/Constantes';
import BarraDeLimite from "../../Componentes/BarraDeLimite";
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useBody } from "../../Body/state/BodyContext";
import {
    Tooltip,
    IconButton,
    Box
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const archivosPermitidos = FILES_PERMITIDOS;

function Adjuntos(props) {
    const theme = useTheme();
    const { setMessage } = useBody();
    const [progress, setProgress] = useState(0);
    const [pesoAcumulado, setPesoAcumulado] = useState(0);
    const [deletingPaths, setDeletingPaths] = useState(new Set());
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const maxSizeFile = props.sizeFile
    const maxSizeFiles = props.sizeFiles

    const customValidator = (file) => {
        if (props.files.find(unFile => unFile.path === file.path))
            return { "error": "Error: No se aceptan archivos con nombres duplicados.", "errorType": "sameName" };

        if (file.size > maxSizeFile)
            return { "error": `Error: El archivo ${file.path} supera el limite permitido por archivo de 2 MB`, "errorType": "maxSizeFile" };

        if (pesoAcumulado > maxSizeFiles)
            return { "error": `Error: No se pueden subir más archivos porque se superó el límite total permitido de 5 MB.`, "errorType": "maxSizeFiles" };
        else {
            setProgress(prevState => {
                return Math.min(prevState + (file.size / maxSizeFiles) * 100, 100)
            })
            setPesoAcumulado(prevState => { return prevState + file.size })
        }
    }

    useEffect(() => {
        const peso = props.files.reduce((acc, file) => acc + file.size, 0)
        setPesoAcumulado(props.files.reduce((acc, file) => acc + file.size, 0))
        setProgress(Math.min((peso / maxSizeFiles) * 100, 100))
    }, [])

    useEffect(() => {
        if (pesoAcumulado > maxSizeFiles && props.files.length > 0) {
            const lastFile = props.files[props.files.length - 1];
            const newFiles = props.files.slice(0, -1);
            setMessage("Se eliminaron archivos porque excedían el límite soportado");
            setProgress(Math.max(((pesoAcumulado - lastFile.size) / maxSizeFiles) * 100, 0));
            setPesoAcumulado(prev => prev - lastFile.size);
            props.agregarAdjuntos(newFiles);
        }
    }, [props.files]);

    const eliminar = (file, indice) => {
        setDeletingPaths(prev => new Set([...prev, file.path]));
        setTimeout(() => {
            const newFiles = [...props.files];
            newFiles.splice(indice, 1);
            setPesoAcumulado(prev => prev - file.size);
            setProgress(prev => Math.max(prev - (file.size / maxSizeFiles) * 100, 0));
            props.agregarAdjuntos(newFiles);
            setDeletingPaths(prev => { const next = new Set(prev); next.delete(file.path); return next; });
        }, 250);
    };

    const setArchivos = (acceptedFiles) => {
        props.agregarAdjuntos([...props.files, ...acceptedFiles]);
    };


    return (
        <div className="container">
            <Grid container
                direction="row"
                justifyContent="flex-start"
                alignItems="baseline">
                <Grid item xs={matches ? 1.5 : 0.75}>
                    <BotonParaSeleccionarArchivo
                        customValidator={customValidator}
                        maxSize={maxSizeFiles}
                        archivosAceptados={archivosPermitidos}
                        setArchivos={setArchivos}
                        pesoAcumulado={pesoAcumulado}
                        setPesoAcumulado={value => setPesoAcumulado(value)}
                        setProgress={value => setProgress(value)}
                    />
                </Grid>
                <Grid item xs={matches ? 8 : 9}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <h4 style={{ margin: 0, marginLeft: 2 }}>
                            {props.files.length === 0 ? 'Sin Adjuntos' : `${props.files.length} ${props.files.length === 1 ? 'Adjunto' : 'Adjuntos'}`}
                        </h4>
                        <Tooltip
                            title={
                                <Box component="ul" sx={{ m: 0, p: 1, pl: 2, fontSize:"12px" }}>
                                    <li>El tamaño máximo por archivo es de 2 MB</li>
                                    <li>El tamaño máximo total de archivos es de 5 MB</li>
                                </Box>
                            }
                            placement="bottom-start"
                        >
                            <IconButton size="small" sx={{ p: 0 }}>
                                <InfoOutlinedIcon sx={{ fontSize: 18, color: 'info.main' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Grid>
                <Grid item xs={2}>
                    <BarraDeLimite progress={progress} sx={{ width: '100%' }} />
                </Grid>
            </Grid>
            <DropZone
                customValidator={customValidator}
                maxSize={maxSizeFiles}
                archivosAceptados={archivosPermitidos}
                setArchivos={setArchivos}
                pesoAcumulado={pesoAcumulado}
                setPesoAcumulado={value => setPesoAcumulado(value)}
                setProgress={value => setProgress(value)}
            />
            <List>
                {props.files.map((file, i) => (
                    <Collapse key={file.path} in={!deletingPaths.has(file.path)} timeout={250}>
                        <FileCard
                            onClick={() => eliminar(file, i)}
                            nombreDelArchivo={file.path.split('/').slice(-1)}
                            type={file.type}
                        />
                    </Collapse>
                ))}
            </List>
        </div>
    );
}

export default Adjuntos;

